import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatVal } from '../../../../helpers/value'
import { LinkComponent } from '../../../common/html/LinkComponent'

export const ItemCount = ({ title, count, href }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element
      className="textCenter"
      style={{
        backgroundColor: '#EFF3FA',
        padding: '6px 16px',
        borderRadius: 4,
      }}
    >
      <Element className="fw500" style={{ fontSize: 14 }}>
        <TextEllipsisStaticLine text={title} lineClamp={1} />
      </Element>
      <LinkComponent href={href}>
        <Element className="fw600" style={{ color: '#2C73E8' }}>
          {formatVal(count, locale, 0, 0)}
        </Element>
      </LinkComponent>
    </Element>
  )
}
